import React from "react";
import RestaurantCard from "./RestaurantCard";
import { LineBreak, Title } from "./Title";
import { gutter } from "./look";

export function Restaurants({ block }) {
  return (
    <div>
      <LineBreak />
      <Title name={block.title} viewAll />
      {block.rows.map((restaurant) => (
        <RestaurantCard key={restaurant.id} restaurant={restaurant} />
      ))}
    </div>
  );
}

export function ViewAllButton({ block }) {
  return (
    <div className="d-flex align-items-center justify-content-center"
      style={{ ...gutter, marginTop: 4, marginBottom: 12, height: 45, borderRadius: 10, background: "#F30404", color: "#fff", fontSize: 15 }}>
      {block.title}
    </div>
  );
}
